module.exports = __webpack_public_path__ + "img/consolidated-apps-urls.4323a6c2.webp";